module.exports = __webpack_public_path__ + "img/culture02.9dd9bb5c.jpg";